import { useMemo } from "react";
import { View, Text, ViewStyle } from "react-native";
import { LinkButton } from "../../components";
import { JobPreferencesFormData } from "./types";

interface LocationsProps {
  formValues: JobPreferencesFormData;
  setLocationsModalVisible: (visible: boolean) => void;
  style?: ViewStyle; // Required for space-y-1 in root component.
}

const Locations = ({ formValues, setLocationsModalVisible, style }: LocationsProps) => {
  const selectedLocations = useMemo(() => {
    const { jobLocations, openToInternational } = formValues;
    const international = openToInternational ? ["International Positions"] : [];
    const locations = jobLocations ? Object.keys(jobLocations).filter((key) => jobLocations[key]) : [];
    return [...international, ...locations].join(", ");
  }, [formValues]);
  return (
    <View className="bg-white px-6 py-8" {...{ style }}>
      <Text className="text-large-normal text-ink-darkest font-700 mb-4">Where would you like to work?</Text>
      <View className="flex flex-row justify-between items-center py-3">
        <View className="flex-1 mr-6">
          <Text className="text-regular-tight text-ink-darkest">Preferred Locations</Text>
          <Text className="text-small-tight text-ink-lighter">{selectedLocations}</Text>
        </View>
        <LinkButton onPress={() => setLocationsModalVisible(true)}>Edit</LinkButton>
      </View>
    </View>
  );
};

export default Locations;
